class CartNotification extends HTMLElement {
  constructor() {
    super();
    this.dialog = this.closest('.cart-notification-modal');
    this.continueButton = this.querySelector('.cart-notification__continue');
  }

  connectedCallback() {
    this.onClickContinueHandler = this.onClickContinue.bind(this);
    this.continueButton.addEventListener('click', this.onClickContinueHandler);
  }

  disconnectedCallback() {
    this.continueButton.removeEventListener('click', this.onClickContinueHandler);
  }

  renderContents(parsedState) {
    // Handle both FormData and JSON response formats
    // When using JSON format (with warranty), key might be in items array
    if (parsedState.key) {
      this.cartItemKey = parsedState.key;
    } else if (parsedState.items && parsedState.items.length > 0) {
      // Get the key from the main product (not warranty)
      // Warranty items typically have properties with parent_id or are nested
      const mainItem = parsedState.items.find(item => {
        // Main product doesn't have parent_id in properties
        return !item.properties || (!item.properties._parent_id && !item.properties.parent_id);
      }) || parsedState.items[parsedState.items.length - 1]; // Fallback to last item
      this.cartItemKey = mainItem ? mainItem.key : null;
    } else {
      // Fallback: try to extract from id if available
      this.cartItemKey = parsedState.id || null;
    }
    
    console.log("key", this.cartItemKey)
    
    // Get sections to render (needs cartItemKey to be set first)
    const sectionsToRender = this.getSectionsToRender();
    
    sectionsToRender.forEach((section) => {
      const sectionElement = document.getElementById(section.id);
      if (!sectionElement) {
        console.warn(`Section element not found: ${section.id}`);
        return;
      }
      
      const sectionHtml = parsedState.sections && parsedState.sections[section.id];
      if (!sectionHtml) {
        console.warn(`Section HTML not found: ${section.id}`);
        return;
      }
      
      try {
        const innerHtml = getInnerHtmlFromText(sectionHtml, section.selector);
        if (innerHtml) {
          sectionElement.innerHTML = innerHtml;
        } else {
          console.warn(`Selector not found in section HTML: ${section.selector}`);
        }
      } catch (error) {
        console.error(`Error rendering section ${section.id}:`, error);
      }
    });

    // Display warranty items if they exist
    this.displayWarrantyItems(parsedState);

    this.open();
    setTimeout(() => {
      const freeProductSlider = document.querySelector(".cart__recommendation-list slider-component");
      if(freeProductSlider) freeProductSlider.init();
    }, 100);
  }

  getSectionsToRender() {
    const selectors = [
      {
        id: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
    
    // Only add cart-notification-product selector if we have a key
    if (this.cartItemKey) {
      selectors.unshift({
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`
      });
    } else {
      // Fallback selector if key is not available
      selectors.unshift({
        id: 'cart-notification-product',
        selector: '.cart-notification-product'
      });
    }
    
    return selectors;
  }

  open() {
    this.dialog.show(this.activeElement);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  onClickContinue() {
    this.dialog.hide();
  }

  displayWarrantyItems(parsedState) {
    if (!parsedState.items || !this.cartItemKey) return;
    
    // Find the main product item
    const mainItem = parsedState.items.find(item => item.key === this.cartItemKey);
    if (!mainItem || !mainItem.variant_id) return;
    
    // Find warranty items that have this main product as parent
    const warrantyItems = parsedState.items.filter(item => {
      if (item.key === this.cartItemKey) return false; // Skip the main item itself
      
      // Check if item has parent_id property matching main product's variant_id
      if (item.properties) {
        const parentId = item.properties._parent_id || item.properties.parent_id;
        if (parentId && String(parentId) === String(mainItem.variant_id)) {
          return true;
        }
      }
      
      // Fallback: Check if items were added together (warranty items typically appear right after main product)
      // Only use this if we have exactly 2 items (main product + warranty) to avoid false positives
      if (parsedState.items.length === 2) {
        const mainItemIndex = parsedState.items.findIndex(i => i.key === this.cartItemKey);
        const itemIndex = parsedState.items.findIndex(i => i.key === item.key);
        if (itemIndex === mainItemIndex + 1 && mainItemIndex >= 0) {
          return true;
        }
      }
      
      return false;
    });
    
    if (warrantyItems.length === 0) return;
    
    // Find the main product element in the notification
    const mainProductElement = document.querySelector(`#cart-notification-product`);
    if (!mainProductElement) return;
    
    const detailsElement = mainProductElement.querySelector('.cart-item__details');
    if (!detailsElement) return;
    
    // Create warranty items container if it doesn't exist
    let warrantyContainer = detailsElement.querySelector('.cart-notification__warranty-items');
    if (!warrantyContainer) {
      warrantyContainer = document.createElement('div');
      warrantyContainer.className = 'cart-notification__warranty-items margin-top-1rem';
      detailsElement.appendChild(warrantyContainer);
    }
    
    // Clear existing warranty items and add new ones
    warrantyContainer.innerHTML = '';
    
    warrantyItems.forEach(warrantyItem => {
      const warrantyElement = document.createElement('div');
      warrantyElement.className = 'cart-notification__warranty-item flex align-center gap-1rem padding-top-0.5rem';
      
      const plusSign = document.createElement('span');
      plusSign.className = 'text-small caption';
      plusSign.textContent = '+';
      
      const warrantyName = document.createElement('span');
      warrantyName.className = 'text-small caption';
      warrantyName.innerHTML = warrantyItem.product_title || warrantyItem.title || 'Warranty';
      
      const warrantyPrice = document.createElement('span');
      warrantyPrice.className = 'text-small caption light';
      // Format price - warrantyItem.final_line_price is in cents
      const price = warrantyItem.final_line_price || 0;
      warrantyPrice.innerHTML = `(${window.Shopify && window.Shopify.formatMoney 
        ? window.Shopify.formatMoney(price) 
        : (price / 100).toFixed(2) + ' €'})`
      
      warrantyElement.appendChild(plusSign);
      warrantyElement.appendChild(warrantyName);
      warrantyElement.appendChild(warrantyPrice);
      warrantyContainer.appendChild(warrantyElement);
    });
  }
}

customElements.define('cart-notification', CartNotification);